<template>
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <table class="table">
        <tbody>
          <tr class="shadow-sm">
            <td class="px-5">
              <h6 class="mb-2 d-flex justify-content-center">
                <strong>
                  {{
                    this.infoData.age[0] === 0
                      ? $t('sigatoka.expecting')
                      : this.infoData.age[0] === 1
                      ? $t('sigatoka.newly_given_birth')
                      : this.infoData.age[0] + ' ' + $t('common_words.weeks')
                  }}
                </strong>
              </h6>
              <el-table
                :data="tableFirst"
                border
                stripe
                height="295"
                class="w-100"
                row-key="id"
              >
                <el-table-column
                  align="center"
                  prop="plant"
                  :label="$t('sigatoka.plants')"
                />
                <el-table-column
                  align="center"
                  prop="functional_leaf"
                  :label="$t('sigatoka.total_functional_leaves')"
                />
                <el-table-column
                  align="center"
                  prop="yls"
                  :label="$t('sigatoka.yls')"
                />
                <el-table-column
                  v-if="this.infoData.age[0] === 0"
                  align="center"
                  prop="yli"
                  :label="$t('sigatoka.yli')"
                />
              </el-table>
            </td>
            <td class="px-5">
              <h6 class="mb-2 d-flex justify-content-center">
                <strong>
                  {{
                    this.infoData.age[1] === 0
                      ? $t('sigatoka.expecting')
                      : this.infoData.age[1] === 1
                      ? $t('sigatoka.newly_given_birth')
                      : this.infoData.age[1] + ' ' + $t('common_words.weeks')
                  }}
                </strong>
              </h6>
              <el-table
                :data="tableSecond"
                border
                stripe
                height="295"
                class="w-100"
                row-key="id"
              >
                <el-table-column
                  align="center"
                  prop="plant"
                  :label="$t('sigatoka.plants')"
                />
                <el-table-column
                  align="center"
                  prop="functional_leaf"
                  :label="$t('sigatoka.total_functional_leaves')"
                />
                <el-table-column
                  align="center"
                  prop="yls"
                  :label="$t('sigatoka.yls')"
                />
                <el-table-column
                  v-if="this.infoData.age[1] === 0"
                  align="center"
                  prop="yli"
                  :label="$t('sigatoka.yli')"
                />
              </el-table>
            </td>
          </tr>
          <tr class="shadow-sm">
            <td class="px-5" :colspan="infoData.age.length > 3 ? 1 : 2">
              <h6 class="mb-2 d-flex justify-content-center">
                <strong>
                  {{ this.infoData.age[2] }} {{ $t('common_words.weeks') }}
                </strong>
              </h6>
              <el-table
                :data="tableThird"
                border
                stripe
                height="295"
                class="w-100"
                row-key="id"
              >
                <el-table-column
                  align="center"
                  prop="plant"
                  :label="$t('sigatoka.plants')"
                />
                <el-table-column
                  align="center"
                  prop="functional_leaf"
                  :label="$t('sigatoka.total_functional_leaves')"
                />
                <el-table-column
                  align="center"
                  prop="yls"
                  :label="$t('sigatoka.yls')"
                />
                <el-table-column
                  v-if="this.infoData.age[2] === 0"
                  align="center"
                  prop="yli"
                  :label="$t('sigatoka.yli')"
                />
              </el-table>
            </td>
            <td class="px-5" v-if="infoData.age.length > 3">
              <h6 class="mb-2 d-flex justify-content-center">
                <strong>
                  {{ this.infoData.age[3] }} {{ $t('common_words.weeks') }}
                </strong>
              </h6>
              <el-table
                :data="tableForth"
                border
                stripe
                height="295"
                class="w-100"
                row-key="id"
              >
                <el-table-column
                  align="center"
                  prop="plant"
                  :label="$t('sigatoka.plants')"
                />
                <el-table-column
                  align="center"
                  prop="functional_leaf"
                  :label="$t('sigatoka.total_functional_leaves')"
                />
                <el-table-column
                  align="center"
                  prop="yls"
                  :label="$t('sigatoka.yls')"
                />
                <el-table-column
                  v-if="this.infoData.age[3] === 0"
                  align="center"
                  prop="yli"
                  :label="$t('sigatoka.yli')"
                />
              </el-table>
            </td>
          </tr>
          <tr class="shadow-sm" v-show="infoData.age.includes(0)">
            <td class="px-5" colspan="2">
              <h6 class="mb-2 d-flex justify-content-center">
                <strong>{{ $t('sigatoka.young_plants') }}</strong>
              </h6>
              <el-table
                :data="tableYoung"
                border
                stripe
                height="295"
                class="w-100"
                row-key="id"
              >
                <el-table-column align="center" type="expand">
                  <template slot-scope="props">
                    <div class="row p-3 bg-light">
                      <h6
                        v-for="(value, index) in props.row.infection"
                        :key="index"
                        class="px-3 mx-2 shadow-sm my-2"
                      >
                        {{ $t('sigatoka.leaf') }} {{ props.row.leaves[index] }}:
                        <div class="d-flex justify-content-center">
                          {{ value }}
                        </div>
                      </h6>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="plant"
                  :label="$t('sigatoka.plants')"
                />
                <el-table-column
                  align="center"
                  prop="functional_leaf"
                  :label="$t('sigatoka.total_functional_leaves')"
                />
                <el-table-column
                  align="center"
                  prop="ref"
                  :label="$t('sigatoka.ref')"
                />
              </el-table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';

export default {
  name: 'step-confirm',
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
  },
  data() {
    return {
      expandedRow: null,
    };
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    toggleRow(index) {
      if (this.expandedRow == index) this.expandedRow = index;
      else this.expandedRow = null;
    },
  },
  computed: {
    tableFirst() {
      const firstStep = this.infoData.first_step;
      if (firstStep == undefined || !firstStep.plant) {
        return [];
      }

      return firstStep.plant.map((plant, index) => {
        return {
          id: index,
          plant: plant,
          functional_leaf: firstStep.functional_leaf[index],
          yls: firstStep.yls[index],
          yli: firstStep.age == 0 ? firstStep.yli[index] : 0,
        };
      });
    },
    tableSecond() {
      const secondStep = this.infoData.second_step;
      if (secondStep == undefined || !secondStep.plant) {
        return [];
      }

      return secondStep.plant.map((plant, index) => {
        return {
          id: index,
          plant: plant,
          functional_leaf: secondStep.functional_leaf[index],
          yls: secondStep.yls[index],
        };
      });
    },
    tableThird() {
      const thirdStep = this.infoData.third_step;
      if (thirdStep == undefined || !thirdStep.plant) {
        return [];
      }

      return thirdStep.plant.map((plant, index) => {
        return {
          id: index,
          plant: plant,
          functional_leaf: thirdStep.functional_leaf[index],
          yls: thirdStep.yls[index],
        };
      });
    },
    tableForth() {
      const forthStep = this.infoData.forth_step;
      if (forthStep == undefined || !forthStep.plant) {
        return [];
      }

      return forthStep.plant.map((plant, index) => {
        return {
          id: index,
          plant: plant,
          functional_leaf: forthStep.functional_leaf[index],
          yls: forthStep.yls[index],
        };
      });
    },
    tableYoung() {
      const fifthStep = this.infoData.fifth_step;
      if (fifthStep == undefined || !fifthStep.plant) {
        return [];
      }

      return fifthStep.plant.map((plant, index) => {
        return {
          id: index,
          plant: plant,
          ref: fifthStep.ref[index],
          functional_leaf: fifthStep.functional_leaf[index],
          infection: fifthStep.infection[index],
          leaves: fifthStep.leaves,
        };
      });
    },
  },
};
</script>
